// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';

const getRuleList = (body = {}, loader = true) => {
  return axios
    .get(`${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.RR.RULES}`, {
      params: body,
      loader,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

const createRule = (body) => {
  return axios
    .post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.RR.RULES}`,
      body
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

const updateRule = (body) => {
  return axios
    .put(`${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.RR.RULES}`, body)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

const deleteRule = (body) => {
  return axios
    .delete(`${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.RR.RULES}`, {
      params: body,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export { getRuleList, createRule, updateRule, deleteRule };
